import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';
import capitalize from 'lodash.capitalize';

import { RESET_STORE } from '../../resetStore/actions';

import { PLAN_GUEST, STATUS_INITIAL, STATUS_UNAUTHENTICATED, STATUS_AUTHENTICATED } from '../../../constants/app';

import * as actions from './actions';

const initialState = {
  apiKey: '',
  err: false,
  errMsg: '',
  email: '',
  firstName: '',
  lastName: '',
  loading: false,
  plan: PLAN_GUEST,
  status: STATUS_INITIAL,
  uuid: '',
};

export default typeToReducer(
  {
    [actions.GET_INFO]: {
      PENDING: (state) => ({
        ...state,
        err: false,
        errMsg: '',
        loading: true,
      }),
      FULFILLED: (state, action) => {
        const { apiKey = '', email, firstName = '', lastName = '', plan, uuid } = action.payload;
        const status = plan !== PLAN_GUEST ? STATUS_AUTHENTICATED : STATUS_UNAUTHENTICATED;

        return {
          ...state,
          apiKey,
          email,
          firstName,
          lastName,
          loading: false,
          plan,
          status,
          uuid,
        };
      },
      REJECTED: (state, action) => {
        const response = get(action, 'payload.e.response', {});
        const errMsg = capitalize(response.data);

        return {
          ...state,
          loading: false,
          err: true,
          errMsg,
          status: STATUS_UNAUTHENTICATED,
        };
      },
    },
    [actions.UPDATE_INFO]: {
      PENDING: (state) => ({
        ...state,
        err: false,
        errMsg: '',
        loading: true,
      }),
      FULFILLED: (state, action) => {
        const { firstName, lastName } = action.payload;

        return {
          ...state,
          loading: false,
          firstName,
          lastName,
        };
      },
      REJECTED: (state, action) => {
        const response = get(action, 'payload.e.response', {});
        const errMsg = capitalize(response.data);

        return {
          ...state,
          loading: false,
          err: true,
          errMsg,
        };
      },
    },
    [actions.GENERATE_API_KEY]: {
      FULFILLED: (state, action) => ({
        ...state,
        apiKey: action.payload,
      }),
    },
    [RESET_STORE]: () => ({
      ...initialState,
      status: STATUS_UNAUTHENTICATED,
    }),
  },
  initialState,
);
